import { ReactNode } from "react";
import { Drawer, Box, Button } from "@chakra-ui/react";

interface FlyoutProps {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  title: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
  maxWidth?: string | number;
  width?: string | number;
  onClose?: () => void;
}

export function Flyout({
  isOpen,
  setIsOpen,
  title,
  children,
  footer,
  maxWidth = "600px",
  width = "100%",
  onClose,
}: FlyoutProps) {
  return (
    <Drawer.Root
      open={isOpen}
      onOpenChange={(details) => {
        setIsOpen(details.open);
        if (!details.open) onClose?.();
      }}
      placement='end'
    >
      <Drawer.Content style={{ height: "100%", maxWidth, width }}>
        <Box
          display='flex'
          justifyContent='space-between'
          alignItems='center'
          p={3}
          borderBottom='1px solid'
          borderColor='gray.200'
        >
          <Box as='h2' fontWeight={600} fontSize={18} color='#2D3748'>
            {title}
          </Box>
          <Box display='flex' gap={4} alignItems='center'>
            <Drawer.CloseTrigger asChild>
              <Button
                variant='ghost'
                aria-label='Close drawer'
                position='relative'
                top={0}
              >
                ×
              </Button>
            </Drawer.CloseTrigger>
          </Box>
        </Box>
        <Drawer.Body>{children}</Drawer.Body>
        {footer && <Drawer.Footer>{footer}</Drawer.Footer>}
      </Drawer.Content>
    </Drawer.Root>
  );
}
